export default ({ request }) => ({
  sysSerialNoRuleListApi(data = {}) {
    return request({
      url: '/sys/serial/no/rule/list',
      method: 'post',
      data,
    })
  },
  sysSerialNoRuleSaveApi(data = {}) {
    return request({
      url: '/sys/serial/no/rule/save',
      method: 'post',
      data,
    })
  },
    sysSerialNoRuleModifyApi(data = {}) {
    return request({
      url: '/sys/serial/no/rule/modify',
      method: 'post',
      data,
    })
  },
  sysSerialNoRuleDetailApi(data = {}) {
    return request({
      url: '/sys/serial/no/rule/detail',
      method: 'post',
      data,
    })
  },
  sysSerialNoRuleDelApi(data = {}) {
    return request({
      url: '/sys/serial/no/rule/del',
      method: 'post',
      data,
    })
  },
})
